import { createContext } from "react";

export type PanePosition = {
  hasPreviousPane: boolean;
};

export const DEFAULT_PANE_POSITION: PanePosition = {
  hasPreviousPane: false,
};

type PaneGroupContextValue = {
  groupId: string;
  container: HTMLDivElement | null;
  positions: Map<string, PanePosition>;
  notifyChange: () => void;
};

export const PaneGroupContext = createContext<PaneGroupContextValue | null>(
  null
);
